import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
// HELPERS
import { Api } from "Helpers";
// REDUX
import { logOutUser } from "Redux/Auth/Actions";
// PREVIEW
import { readPreviewInfo } from "./previewSession";

/** Small fixed pill on every page of a teacher's "Preview as Student" session. */
const PreviewBanner = () => {
	const dispatch = useDispatch();
	const isLoggedIn = useSelector((state) => state.Auth.isLoggedIn);
	const info = isLoggedIn ? readPreviewInfo() : null;

	if (!info) return null;

	const endPreview = () => {
		const data = new FormData();
		data.append("token", localStorage.getItem("accessToken"));
		new Api().post("user/logout", { data });
		dispatch(logOutUser());
		// The CMS opened this tab, so it can close it; otherwise the landing page shows.
		window.close();
	};

	const title = info.assessmentName ? `Student preview: ${info.assessmentName}` : "Student preview";

	return (
		<Pill role="status" title={`${title}. Nothing you do here counts toward class results.`}>
			<span className="dot" aria-hidden="true" />
			<span className="label">{title}</span>
			<button type="button" onClick={endPreview}>
				End preview
			</button>
		</Pill>
	);
};

const Pill = styled.div`
	position: fixed;
	left: 16px;
	bottom: 16px;
	z-index: 1400;
	display: flex;
	align-items: center;
	gap: 10px;
	max-width: calc(100vw - 32px);
	padding: 8px 8px 8px 14px;
	border-radius: 999px;
	background: rgba(12, 20, 39, 0.92);
	color: #ffffff;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0.3px;
	box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);

	.dot {
		flex: 0 0 auto;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background: #3fdc9a;
	}

	.label {
		min-width: 0;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		max-width: 320px;
	}

	button {
		flex: 0 0 auto;
		border: 0;
		border-radius: 999px;
		padding: 6px 12px;
		background: #ffffff;
		color: #0c1427;
		font-size: 12px;
		font-weight: 600;
		cursor: pointer;
	}
`;

export default PreviewBanner;
